'use client';

import { useEffect } from 'react';

import { useAdyen } from '../../hooks';
import type { AdyenFormProps } from './types';

import '@adyen/adyen-web/styles/adyen.css';
import './AdyenForm.scss';

export function AdyenForm({ setAdyenForm, setAdyenFormState, holderNameError }: AdyenFormProps) {
    const { adyenForm, adyenFormState } = useAdyen();

    useEffect(() => {
        setAdyenForm(adyenForm);
        setAdyenFormState(adyenFormState);
    }, [adyenForm, adyenFormState]);

    useEffect(() => {
        const input = document.querySelector<HTMLInputElement>('.adyen-checkout__card__holderName__input');
        input?.classList.toggle('adyen-checkout__input--error', !!holderNameError);
    }, [holderNameError]);

    return (
        <div className="adyen-form" data-testid="adyen-form">
            <div id="adyen-card-container" data-cs-mask />
            {holderNameError && (
                <span
                    className="adyen-form__holder-name-error adyen-checkout-contextual-text--error"
                    data-testid="holder-name-error"
                >
                    {holderNameError}
                </span>
            )}
        </div>
    );
}
